import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import type { DateTime } from 'luxon';
import { TIMESTAMP_SECONDS_FORMAT } from '../../utils/date-time';

type Format = 'timeAgo' | 'date' | 'dateShort' | 'timestamp' | 'timestampSeconds';

@Component({
    selector: 'app-timestamp',
    templateUrl: './timestamp.component.html',
    styleUrls: ['./timestamp.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimestampComponent {
    @Input({ required: true }) timestamp: DateTime | string;
    @Input() timeAgo = false;
    @Input() format: Format = 'timestamp';
    @Input() tooltip: string = undefined;

    @HostBinding('class.app-timestamp--underline')
    @Input() underline = false;

    public readonly timestampSecondsFormat = TIMESTAMP_SECONDS_FORMAT;
}
